import { ascending } from 'd3'

export function makeRows (entities) {
  if (!entities) return []
  if (!Array.isArray(entities)) return []
  if (entities.length === 0) return []

  entities.sort(function (a, b) {
    return ascending(a.name, b.name)
  })

  return entities
}
